function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#202124",
  fillRule: "nonzero",
  stroke: "#000",
  strokeWidth: 0.6
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M20.262 5l-1.284-1.284c-.954-.955-2.618-.955-3.573 0l-1.66 1.66-.005.005-.005.005L3.85 15.27c-.109.108-.178.25-.2.401l-.642 4.493c-.032.222.043.445.2.603.134.136.315.21.503.21.033 0 .067-.002.1-.007l4.494-.642c.151-.021.293-.092.401-.2l9.885-9.886.005-.005.004-.005 1.66-1.66c.478-.477.741-1.11.741-1.786 0-.675-.262-1.31-.738-1.787zM7.87 18.955l-3.32.475.474-3.322 9.22-9.22 2.846 2.847-9.22 9.22zM19.257 7.567l-1.163 1.164-2.846-2.847 1.163-1.163c.418-.419 1.145-.419 1.562 0l1.284 1.284c.21.209.323.487.323.782 0 .295-.114.572-.323.78z",
  transform: "translate(-105 -331) translate(0 120) translate(16 85) translate(89.5 126)"
}))))));

var SvgIconEdit = function SvgIconEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-edit.1a19f1de.svg";
export { ForwardRef as ReactComponent };